<script setup>
import { onBeforeUnmount, onBeforeMount, ref, computed } from "vue";
import { useRouter , useRoute } from "vue-router";
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core';
import { required, sameAs, minLength } from '@vuelidate/validators';
import { useStore } from "vuex";
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
import logo from "@/assets/img/logo-ct-dark.png";

const url = ref(process.env.VUE_APP_API_URL);
const store = useStore();
const route = useRoute();
const router = useRouter();
const success = ref('');
const errorHeader = ref('');
const password = ref('');
const confirmPassword = ref('');
const isPasswordLoading = ref(false);

const passwordRules = computed(() => {
  return {
    password: { required, minLength: minLength(6) },
    confirmPassword: { required, sameAs: sameAs(password) }
  }
});
const $vPassword = useVuelidate(passwordRules, {
  password,
  confirmPassword,
});

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});


const resetPassword = () => {
  errorHeader.value = '';
  success.value = '';
  $vPassword.value.$touch();
  if ($vPassword.value.$invalid) {
    return;
  }
  isPasswordLoading.value = true;
  axios
    .post(url.value + "api/resetPassword", {
      password: password.value,
      password_confirmation: confirmPassword.value,
      token : route.params.token,
      email : route.query.email
    })
    .then((res) => {
      success.value = res.data.success;
      isPasswordLoading.value = false;
      password.value = "";
      confirmPassword.value = "";
      $vPassword.value.$reset();
      setTimeout(() => {
        router.push("/signin");
      }, 3000);
      console.log(res);
    }).catch((error) => {
      errorHeader.value = error.response.data.error;
      isPasswordLoading.value = false;
      console.log(error);
      // if (error.response?.data && error.response?.data.error) {
      //   errorHeader.value = error.response.data.error;
      // }
    });
};
</script>
<template>

  <main
    class="mt-0 main-content position-relative h-100 d-flex flex-column justify-content-center overflow-hidden custom-bg">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row justify-content-center">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card login-card">
                <div class="pb-0 card-header text-start">
                  <div class="d-flex justify-content-center mb-3 align-items-center">
                    <img :src="logo" alt="US Flag" class="custom-logo" />


                  </div>

                  <h5 class="text-center">Reset Password</h5>
                  <p class="mb-0 fs-14 text-center">Please enter password and confirm password.</p>
                </div>
                <div class="card-body">
                  <form role="form">
                    <p v-if="errorHeader" class="text-danger">{{ errorHeader }}</p>
                    <p v-if="success" class="text-success">{{ success }}</p>
                    <div class="mb-3">
                      <input id="password" class="form-control" v-model="password" type="password" placeholder="Password"
                        size="lg" :class="{ 'is-invalid': $vPassword.password.$error }" />
                      <p class="text-danger" v-if="$vPassword.password.$error">
                        <span v-if="!$vPassword.password.$pending && !$vPassword.password.$model">Password is
                          required.</span>
                        <span
                          v-if="!$vPassword.password.$pending && $vPassword.password.$model && !$vPassword.password.$params">Password
                          must be at least 6 characters long.</span>
                      </p>
                    </div>
                    <div class="mb-3">
                      <input id="confirmpassword" class="form-control" v-model="confirmPassword" type="password"
                        placeholder="Confirm Password" size="lg" :class="{ 'is-invalid': $vPassword.confirmPassword.$error }" />
                      <p class="text-danger" v-if="$vPassword.confirmPassword.$error">
                        <span v-if="!$vPassword.confirmPassword.$pending && !$vPassword.confirmPassword.$model">Confirm
                          Password is required.</span>
                        <span
                          v-if="!$vPassword.confirmPassword.$pending && $vPassword.confirmPassword.$model && !$vPassword.confirmPassword.$params">Passwords
                          do not match.</span>
                      </p>
                    </div>



                    <div class="text-center">
                      <argon-button class="mt-4" type="button" variant="gradient" color="success" fullWidth size="lg"
                        @click="resetPassword" :disabled="isPasswordLoading">Reset Password</argon-button>
                    </div>
                  </form>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<style>
.card-plain.login-card {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
  padding: 20px 0px;
}

.custom-bg {
  background: url("@/assets/img/image (1).webp");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  /* background-image: linear-gradient(310deg, #2dce89 0%, #2dcecc 100%);
  background: #7b5540; */
  position: relative;
}

.custom-bg:before {
  position: absolute;
  content: '';
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: #00000082;
}

.custom-logo {
  max-width: 45px;
  width: 100%;
}

.fs-14 {
  font-size: 14px;
}

.form-switch .form-check-input:checked {
  border-color: #7b5540 !important;
  background-color: #7b5540 !important;
}

.form-control:focus {
  border-color: #7b5540 !important;
}

.bg-gradient-success {
  background: #7b5540 !important;
}

.text-gradient.text-success {
  color: #7b5540 !important;
  -webkit-text-fill-color: none;
}
</style>
